import script from "./SelectCareItems.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectCareItems.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__